import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49f05a0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page relative text-white pt-4 md:pt-8" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 lg:mb-10 px-4 lg:px-10"
}
const _hoisted_3 = {
  key: 0,
  class: "swiper",
  ref: "featured"
}
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination !relative !top-0 !left-0 !bottom-0" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "animate-pulse"
}
const _hoisted_7 = { class: "mb-6 lg:mb-10 space-y-4" }
const _hoisted_8 = {
  key: 0,
  class: "px-4 lg:px-10 font-black lg:text-xl"
}
const _hoisted_9 = {
  key: 1,
  class: "showtimes grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 px-4 lg:px-10"
}
const _hoisted_10 = {
  key: 2,
  class: "showtimes grid grid-cols-2 md:grid-cols-4 gap-4 px-4 lg:px-10"
}
const _hoisted_11 = {
  key: 1,
  class: "mb-6 lg:mb-10 space-y-4"
}
const _hoisted_12 = {
  key: 0,
  class: "px-4 lg:px-10 font-black lg:text-xl"
}
const _hoisted_13 = {
  key: 1,
  class: "showtimes grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 px-4 lg:px-10"
}
const _hoisted_14 = {
  id: "refund",
  class: "px-4 lg:px-10 mb-6 lg:mb-10"
}
const _hoisted_15 = {
  id: "refundContainer",
  class: "p-8 bg-neutral-800 space-y-8 rounded-md"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "text",
  class: "space-y-1"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center font-semibold" }, "¿Tenés una compra y te arrepentiste?"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm" }, "Podés solicitar una devolución hasta 1 hora antes de la función.")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs" }, "En cumplimiento con la resolución 424/2020 Secretaría de Comercio Interior", -1))
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "whatsAppButton bg-green-700 w-14 h-14 p-4 rounded-full fixed bottom-4 right-4 z-10 shadow-md" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full h-full object-contain object-center",
    src: "/assets/icons/whatsapp-brands.svg",
    alt: ""
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_MovieItem = _resolveComponent("MovieItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$store.state.kioskMode)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          (_ctx.featured && _ctx.featured.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featured, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "swiper-slide",
                      key: index
                    }, [
                      item
                        ? (_openBlock(), _createBlock(_component_Banner, {
                            key: 0,
                            image: item.url
                          }, null, 8, ["image"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _hoisted_5
              ], 512))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_Banner)
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_7, [
      (!_ctx.$store.state.kioskMode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " COMPRÁ TU ENTRADA "))
        : _createCommentVNode("", true),
      (_ctx.nowPlaying.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nowPlaying, (item, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                to: '/pelicula/' + _ctx.$store.state.cinemaInfo.id + '/' + item.pref,
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MovieItem, {
                    title: item.nombre,
                    poster: (item.poster) ? item.poster.path : _ctx.noPoster,
                    formato: item.formato,
                    release: item.release,
                    preSale: item.preSale,
                    lenguaje: item.lenguaje
                  }, null, 8, ["title", "poster", "formato", "release", "preSale", "lenguaje"])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createVNode(_component_MovieItem, { key: index })
            }), 64))
          ]))
    ]),
    (_ctx.theaterPlays.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
          (!_ctx.$store.state.kioskMode)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, " CARTELERA DE TEATRO "))
            : _createCommentVNode("", true),
          (_ctx.theaterPlays.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theaterPlays, (item, index) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    to: '/pelicula/' + _ctx.$store.state.cinemaInfo.id + '/' + item.pref,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MovieItem, {
                        title: item.nombre,
                        poster: (item.poster) ? item.poster.path : _ctx.noPoster,
                        formato: item.formato,
                        release: item.release,
                        preSale: item.preSale,
                        lenguaje: item.lenguaje
                      }, null, 8, ["title", "poster", "formato", "release", "preSale", "lenguaje"])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_router_link, {
          to: "/devolucion",
          class: "block"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, { class: "h-9 !w-fit rounded-md !bg-blue-600 block mx-auto px-4 font-semibold flex items-center justify-center" }, {
              default: _withCtx(() => [
                _createTextVNode("Solicitar devolución")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_17
      ])
    ]),
    (_ctx.$store.state.cinemaInfo.Whatsapp)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: 'https://wa.me/' + _ctx.cinemaInfo.Whatsapp,
          target: "blank"
        }, _hoisted_20, 8, _hoisted_18))
      : _createCommentVNode("", true)
  ]))
}